/**
 * https://codesandbox.io/s/open-base64-pdf-in-new-tab-forked-c1biu0?file=/src/index.tsx:326-1045
 * @param base64Data
 * @returns
 */
const base64toBlob = (base64Data: string) => {
  // Split the data from the header
  const [header, data] = base64Data.split(",");

  // Get the type from the header
  const type = header.slice(header.indexOf(":") + 1, header.indexOf(";"));

  const sliceSize = 1024;
  const byteCharacters = atob(data);
  const bytesLength = byteCharacters.length;
  const slicesCount = Math.ceil(bytesLength / sliceSize);
  const byteArrays = new Array(slicesCount);

  for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    const begin = sliceIndex * sliceSize;
    const end = Math.min(begin + sliceSize, bytesLength);

    const bytes = new Array(end - begin);
    for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  return new Blob(byteArrays, { type });
};

export default base64toBlob;
